import React from "react";
import { isEmbedded } from "src/utils/appBridgeInit";

import OnboardingBootSkeleton from "./OnboardingBootSkeleton";

/** Route-level onboarding loading UI for boot / rehydrate (no Polaris AppProvider required). */
export const OnboardingLoadingShell: React.FC = () => {
  const embedded = isEmbedded();

  if (embedded) {
    return (
      <div role="status" aria-live="polite" aria-label="Loading onboarding">
        <div style={{ padding: "16px" }}>
          <OnboardingBootSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading onboarding"
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        background: "#f6f6f7",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ flex: 1, minWidth: 0, maxWidth: 980 }}>
        <OnboardingBootSkeleton />
      </div>
    </div>
  );
};

export default OnboardingLoadingShell;
